import ar from './plus_one_arabic.json';
import countries from './countries.json';
import errors from './errors.json';

export default {
  ...ar,
  ...countries,
  ...errors
};
